import axios from 'axios';
import {fetchSessionToken} from "../utils/getSessionToken";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL, // Use the base URL from .env
    withCredentials: true, // Include credentials if needed
});

// Intercept each request to attach the session token
axiosInstance.interceptors.request.use(async (config) => {
    const token = await fetchSessionToken();
    console.log("Token", token);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default axiosInstance;
